import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';

import { LoginInput } from '../../lib/form/fields';
import { requiredField, emailField, minLength } from '../../lib/form/validators';

const LoginForm = ({ valid, handleSubmit, onSubmit, loading }, context) => {
  const [state, setState] = useState({ pwdUnmasked: false });
  const pwdMaskToggle = () => {
    setState({ pwdUnmasked: !state.pwdUnmasked });
  };

  return (
    <form onSubmit={handleSubmit(values => onSubmit(values))}>
      <Field
        name="email"
        type="email"
        label={context.t('LOGIN-FORM.EMAIL.LABEL')}
        placeholder={context.t('LOGIN-FORM.EMAIL.PLACEHOLDER')}
        component={LoginInput}
      />

      <Field
        name="password"
        type={state.pwdUnmasked ? 'text' : 'password'}
        label={context.t('LOGIN-FORM.PASSWORD.LABEL')}
        labelMeta={
          <Link to="/forgot-password" className="form-text">
            {context.t('LOGIN-FORM.FORGOT-PASSWORD.LINK')}
          </Link>
        }
        placeholder={context.t('LOGIN-FORM.PASSWORD.PLACEHOLDER')}
        component={LoginInput}
        appendInput={
          <span
            className={`input-group-text ${state.pwdUnmasked ? 'text-primary' : ''}`}
            onClick={() => pwdMaskToggle()}
          >
            <i className="fa fa-eye" />
          </span>
        }
      />
      <button
        className="btn btn-lg btn-block btn-primary mb-3"
        style={{ height: 48, color: 'white', fontSize: 16, borderRadius: 4 }}
        disabled={!valid}
      >
        {context.t('LOGIN-FORM.BUTTON.LOGIN')}
        {loading && (
          <div className="spinner-border spinner-border-sm ml-2" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        )}
      </button>
    </form>
  );
};

LoginForm.contextTypes = {
  t: PropTypes.func.isRequired,
};

const loginFormValidator = formProps => {
  const errors = {};
  requiredField(formProps, errors, 'email', 'LOGIN-FORM.EMAIL.ERROR_REQUIRED');
  emailField(formProps, errors, 'email', 'LOGIN-FORM.EMAIL.WRONG_FORMAT');
  requiredField(formProps, errors, 'password', 'LOGIN-FORM.PASSWORD.ERROR_REQUIRED');
  minLength(formProps, errors, 'password', 3, 'LOGIN-FORM.PASSWORD.ERROR_MIN_LENGTH');
  return errors;
};

export default reduxForm({
  form: 'LoginForm',
  validate: loginFormValidator,
})(LoginForm);
